<!--
 * @Author: 仙道
 * @Date: 2022-09-18 12:01:13
 * @LastEditTime: 2022-09-21 21:34:42
 * @email: hao.li08@weimob.com+
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/workbench/components/defRegister.vue
-->
<!--
 * @Author: 仙道
 * @Date: 2022-06-21 16:12:52
 * @LastEditTime: 2022-09-18 11:02:23
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/workbench/components/PanelOne.vue
-->
 
<template>
  <grid-table :columns="columns" :queryParams="queryParams" :url="url" ref="table">
    <span slot="defLevel" slot-scope="priority, record">
      <a-tag :color="$filterDictTextByCache('def_level_color', record.defLevel)">{{record.defLevel_dictText}}</a-tag>
    </span>
  </grid-table>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GridTable from "./Itable";

  export default {
    // 未处理缺陷
    name: 'DefRegister',
    components: {
      GridTable,
    },

    // 定义属性
    data () {
      return {
        url: '/device/defRegister/list',
        queryParams: {
          defStatusStr: '0,1,2',
        },
        columns: [
          {
            title: '设备名称',
            align: "center",
            dataIndex: 'devName',
            sorter: true,
          },
          {
            title: '缺陷内容',
            align: "center",
            dataIndex: 'defContent'
          },
          {
            title: '缺陷部位',
            align: "center",
            dataIndex: 'defPart'
          },
          {
            title: '缺陷类别',
            align: "center",
            dataIndex: 'defCategory',
          },
          {
            title: '缺陷等级',
            align: "center",
            dataIndex: 'defLevel',
            scopedSlots: { customRender: 'defLevel' },
            sorter: true,
          },
          {
            title: '缺陷发现人',
            align: "center",
            dataIndex: 'defInventor_dictText'
          },
          {
            title: '缺陷发现时间',
            align: "center",
            dataIndex: 'defFindTime',
            width: 180,
            sorter: true,
          },
        ],
      }
    },

    // 方法集合
    methods: {
      queryData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>
 